import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { computed, onBeforeMount, onBeforeUnmount, onDeactivated, onMounted, onUnmounted, ref } from "@vue/composition-api";
export const useWidgetEvents = setupContext => {
  const closeWidgetOnExit = ref(true);
  const validEvents = ["refresh", "pre-fetch", "sync", "request-sync", "navigate-validation-rule", "dismiss-validations"];
  const widgetPopoverInstance = computed({
    get() {
      return setupContext.root.widgetPopover;
    },
    set(popoverInstance) {
      setupContext.root.widgetPopover = popoverInstance;
    }
  });
  let onWidgetMessageCallback = () => {};
  const onWidgetMessage = cb => {
    onWidgetMessageCallback = cb;
  };
  const sendWidgetMessage = (target, type, data) => {
    if (widgetPopoverInstance.value) {
      widgetPopoverInstance.value.postMessage({
        type,
        data,
        target
      }, window.location.origin);
    }
  };
  const sendOpenerWidgetMessage = (target, type, data) => {
    if (window.opener) {
      window.opener.postMessage({
        type,
        data,
        target
      }, window.location.origin);
    }
  };
  const setCloseWidgetOnExit = val => {
    closeWidgetOnExit.value = val;
  };
  const closeWidgetPopover = () => {
    if (!closeWidgetOnExit.value) return;
    if (widgetPopoverInstance.value) {
      widgetPopoverInstance.value.close();
      widgetPopoverInstance.value = null;
    }
  };
  const bindWidgetWindowMessage = () => {
    window.addEventListener("message", receiveWindowMessage, false);
  };
  const unbindWidgetWindowMessage = () => {
    window.removeEventListener("message", receiveWindowMessage);
  };
  const receiveWindowMessage = event => {
    if (event.origin !== window.location.origin || !_includesInstanceProperty(validEvents).call(validEvents, event.data.type)) {
      return;
    }
    onWidgetMessageCallback(event.data);
  };
  onBeforeMount(() => {
    closeWidgetOnExit.value = true;
  });
  onMounted(() => {
    bindWidgetWindowMessage();
  });
  onBeforeUnmount(() => {
    closeWidgetPopover();
  });
  onDeactivated(() => {
    closeWidgetPopover();
  });
  onUnmounted(() => {
    unbindWidgetWindowMessage();
  });
  return {
    sendWidgetMessage,
    sendOpenerWidgetMessage,
    setCloseWidgetOnExit,
    closeWidgetPopover,
    onWidgetMessage
  };
};